/**
 * Physiofit privacy footer note (ERS-5, document from ERS-42)
 *
 * Renders "Es gilt die Datenschutzerklärung der Physiofit Digital GmbH." with the second half
 * linked, shown once per screen in {@link OnboardingFooter} (ERS-61). Self-contained: owns the
 * drawer that displays the document, so a screen only has to drop the component in.
 */

import { type MouseEvent, useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../styles/colors';
import { text } from '../../../../styles/onboardingUiTokens';
import { PhysiofitPrivacyDrawer } from './PhysiofitPrivacyDrawer';

const Note = styled.p`
  margin: 0;
  text-align: center;
  color: ${colors.medium};
  font-size: ${text.mini.fontSize};
  line-height: ${text.mini.lineHeight};
`;

const linkStyle = { color: 'inherit', textDecoration: 'underline' as const };

export function PhysiofitPrivacyNote() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setIsOpen(true);
  };

  return (
    <>
      <Note>
        Es gilt die{' '}
        <a href="#" onClick={handleOpen} style={linkStyle}>
          Datenschutzerklärung
        </a>{' '}
        der Physiofit Digital GmbH.
      </Note>
      <PhysiofitPrivacyDrawer open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
